export const SPACE_UNIT_VALUE = 5;
